import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import { GlobalModals } from '../../constants/AppConstants';
import ModalActions from '../../actions/ModalActions';

import Icon from '../general/Icon';

function LoginLink ({ onClick, showIcon, className }) {

    const _handleClick = () => ModalActions.open(GlobalModals.LOGIN) && onClick();

    return (
        <button type="button"
                aria-label={ t('ariaLabel.openLogin') }
                className={ className }
                onClick={ _handleClick }>
            { showIcon && <Icon icon="user" /> }
            { t('account.login') }
        </button>
    );

}

LoginLink.propTypes = {
    className: PropTypes.string,
    showIcon: PropTypes.bool,
    onClick: PropTypes.func
};

LoginLink.defaultProps = {
    className: 'btn btn-primary btn-lg btn-login',
    showIcon: true,
    onClick: _.noop
};

export default LoginLink;



// WEBPACK FOOTER //
// ./src/components/nav/LoginLink.js